import * as Popper from "@popperjs/core";

const NAME = "dropdown";

type Config = {
  placement: "top" | "right" | "bottom" | "left";
};

const DefaultConfig: Config = {
  placement: "bottom",
};

class Dropdown {
  private targetElem: HTMLElement;

  private triggerElem: HTMLElement;

  private isShown = false;

  private popper: Popper.Instance | null = null;

  private config: Config;

  private boundHandleClickOutside: (ev: MouseEvent) => void;

  constructor(
    triggerElement: HTMLElement,
    targetElement: HTMLElement,
    config?: Config,
  ) {
    this.targetElem = targetElement;
    this.triggerElem = triggerElement;
    this.config = { ...DefaultConfig, ...(config || {}) };
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    this.triggerElem.addEventListener("click", () => {
      this.toggle();
    });
  }

  static get NAME() {
    return NAME;
  }

  private handleClickOutside(ev: MouseEvent): void {
    const clickedElem = ev.target as Node;
    if (
      clickedElem !== this.targetElem &&
      !this.targetElem.contains(clickedElem) &&
      !this.triggerElem.contains(clickedElem) &&
      this.isShown
    ) {
      this.hide();
    }
    document.body.removeEventListener(
      "click",
      this.boundHandleClickOutside,
      true,
    );
  }

  toggle(): void {
    if (this.isShown) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(): void {
    this.targetElem.style.display = "block";

    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
    }

    document.body.addEventListener("click", this.boundHandleClickOutside, true);

    this.popper = Popper.createPopper(this.triggerElem, this.targetElem, {
      placement: this.config.placement,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10],
          },
        },
      ],
    });

    this.popper.update();
    this.isShown = true;
  }

  hide(): void {
    this.targetElem.style.display = "none";
    document.body.removeEventListener(
      "click",
      this.boundHandleClickOutside,
      true,
    );
    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
    }
    this.isShown = false;
  }

  dispose(): void {
    this.hide();
    this.triggerElem.removeEventListener("click", () => {
      this.toggle();
    });
  }
}

export default Dropdown;
